var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivoritLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 41,
    viewBox: "0 0 135 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5326 27.9071H57.8194V32.3167H46.6835C46.4261 32.3167 46.1793 32.2147 45.9972 32.0331C45.8152 31.8515 45.713 31.6052 45.713 31.3484V9.68146H49.5621C49.8195 9.68146 50.0664 9.78348 50.2484 9.96507C50.4304 10.1467 50.5326 10.393 50.5326 10.6498V27.9071Z",
    fill: "#060709"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.238 32.3167V15.2047H64.9023V32.3167H60.238Z",
    fill: "#060709"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6871 15.2067H84.9031L77.857 32.3167H73.8351C71.5149 26.6127 69.1934 20.9094 66.8706 15.2067H71.0536C71.2558 15.206 71.4531 15.2683 71.6181 15.385C71.783 15.5017 71.9073 15.6668 71.9736 15.8574L75.8558 26.9078L79.7612 15.8574C79.8278 15.6659 79.953 15.5 80.1192 15.3833C80.2853 15.2666 80.4839 15.2048 80.6871 15.2067Z",
    fill: "#060709"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6262 32.6498C92.0045 32.6814 90.3991 32.322 88.9463 31.6021C87.5953 30.9139 86.4783 29.8426 85.7358 28.5229C84.9594 27.1685 84.5711 25.576 84.5711 23.7452C84.5711 21.0043 85.4071 18.8404 87.079 17.2537C88.7509 15.6669 90.9333 14.8735 93.6262 14.8735C96.3282 14.8735 98.5158 15.6669 100.189 17.2537C101.862 18.8404 102.699 21.0043 102.699 23.7452C102.699 26.4978 101.862 28.6701 100.189 30.262C98.5158 31.8539 96.3282 32.6498 93.6262 32.6498ZM93.5777 28.8386C94.9287 28.8386 96.0196 28.3725 96.8503 27.4403C97.6811 26.5082 98.0971 25.2765 98.0984 23.7452C98.0984 22.2127 97.6824 20.981 96.8503 20.0502C96.0183 19.1193 94.9274 18.6532 93.5777 18.6519C92.9764 18.6345 92.3789 18.7518 91.829 18.9951C91.2791 19.2384 90.7909 19.6016 90.4002 20.0579C89.581 20.9978 89.1715 22.2243 89.1715 23.7375C89.1715 25.2506 89.581 26.4772 90.4002 27.4171C90.7894 27.8762 91.277 28.2423 91.8269 28.4883C92.3769 28.7344 92.9752 28.8541 93.5777 28.8386Z",
    fill: "#060709"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.166 18.1193C109.605 17.3202 110.329 16.6346 111.338 16.0626C112.321 15.4981 113.436 15.2028 114.57 15.2067V19.4847C112.748 19.4847 111.43 19.8287 110.614 20.5169C109.799 21.205 109.392 22.4251 109.392 24.1771V32.3109H104.733V15.2067H108.196C108.453 15.2067 108.7 15.3087 108.882 15.4903C109.064 15.6719 109.166 15.9182 109.166 16.175V18.1193Z",
    fill: "#060709"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.775 32.3167V15.2047H121.44V32.3167H116.775Z",
    fill: "#060709"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.943 32.3167C130.336 32.3167 129.092 31.8539 128.212 30.9282C127.332 30.0025 126.892 28.6843 126.892 26.9736V18.8862H123.643V15.2067H125.456C125.972 15.2031 126.465 14.9963 126.828 14.6314C127.192 14.2665 127.396 13.773 127.397 13.2584V9.68146H131.58V15.2067H134.99V18.8862H131.59V26.4585C131.59 27.9342 132.228 28.672 133.503 28.672H135V32.3167H131.943Z",
    fill: "#060709"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.238 8.51367H63.926C64.1834 8.51367 64.4303 8.61569 64.6123 8.79728C64.7943 8.97888 64.8965 9.22517 64.8965 9.48199V13.1616H61.2085C60.9511 13.1616 60.7042 13.0596 60.5222 12.878C60.3402 12.6964 60.238 12.4501 60.238 12.1933V8.51367Z",
    fill: "#060709"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.775 8.51367H120.463C120.721 8.51367 120.968 8.61569 121.15 8.79728C121.332 8.97888 121.434 9.22517 121.434 9.48199V13.1616H117.746C117.488 13.1616 117.242 13.0596 117.06 12.878C116.878 12.6964 116.775 12.4501 116.775 12.1933V8.51367Z",
    fill: "#060709"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0351 33.0797L0.0112225 24.4269V14.0814C-0.00654796 12.8762 0.302887 11.6887 0.906726 10.6447C1.51056 9.60068 2.3863 8.73917 3.44108 8.15148L14.841 1.58438C15.8778 0.968445 17.0621 0.643311 18.2689 0.643311C19.4756 0.643311 20.6599 0.968445 21.6968 1.58438L22.1704 1.85745L8.08799 9.96804C7.35627 10.393 6.82297 11.0898 6.60473 11.906C6.38648 12.7222 6.50104 13.5914 6.92335 14.3235L16.7781 31.3523C16.9173 31.5936 16.9729 31.8741 16.9362 32.1501C16.8996 32.4262 16.7728 32.6825 16.5754 32.8794C16.378 33.0763 16.1211 33.2028 15.8444 33.2394C15.5678 33.2759 15.2867 33.2205 15.0448 33.0817L15.0351 33.0797Z",
    fill: "url(#paint0_linear_3231_1138)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6694 34.5233L21.6939 39.6999C20.6562 40.3173 19.4704 40.6433 18.2621 40.6433C17.0539 40.6433 15.8681 40.3173 14.8303 39.6999L3.43045 33.1347C2.37711 32.5473 1.50237 31.687 0.898647 30.6446C0.294924 29.6021 -0.0153595 28.4164 0.000584944 27.2125V26.6664L14.0811 34.7809C14.815 35.2017 15.686 35.3157 16.504 35.098C17.3219 34.8803 18.0202 34.3485 18.4465 33.6189L28.3013 16.5766C28.4412 16.3355 28.6568 16.1471 28.9149 16.0407C29.1729 15.9342 29.4589 15.9156 29.7286 15.9878C29.9983 16.0599 30.2366 16.2187 30.4067 16.4396C30.5768 16.6606 30.6691 16.9313 30.6694 17.2099V34.5233Z",
    fill: "url(#paint1_linear_3231_1138)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0791 11.6379L24.1029 2.98315L33.0862 8.15007C34.1408 8.73815 35.0164 9.59969 35.6205 10.6435C36.2246 11.6874 36.5347 12.8748 36.518 14.08V27.2123C36.535 28.4164 36.2257 29.6027 35.6226 30.6458C35.0195 31.689 34.1452 32.5501 33.092 33.1384L32.6184 33.4114V17.1883C32.6168 16.3433 32.2797 15.5334 31.6809 14.936C31.0821 14.3385 30.2703 14.0022 29.4234 14.0006H9.71383C9.43461 14.0003 9.16328 13.9082 8.94184 13.7385C8.7204 13.5688 8.56122 13.331 8.48893 13.062C8.41664 12.7929 8.43529 12.5075 8.54198 12.2501C8.64867 11.9927 8.83745 11.7775 9.0791 11.6379Z",
    fill: "url(#paint2_linear_3231_1138)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3231_1138",
    x1: 5.41515,
    y1: 27.539,
    x2: 20.697,
    y2: 1.00989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1460DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1C8AE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3231_1138",
    x1: 30.6694,
    y1: 28.2951,
    x2: 0.000584961,
    y2: 28.2951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0047BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1460DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3231_1138",
    x1: 18.699,
    y1: 6.09725,
    x2: 33.9808,
    y2: 32.6264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1C8AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0047BB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivoritLogoDark);
export default __webpack_public_path__ + "static/media/livorit-logo-dark.efee3c32884ffe3b0924862fd48d1c2b.svg";
export { ForwardRef as ReactComponent };